"use client";
import { useQuery } from "@tanstack/react-query";
import { fetch } from "libs";
import { GET_ALL_TRANSACTIONS } from "api";

const fetchCreditTransactions = async ({ queryKey }: any) => {
  const [, { page, pageSize, query, start_date, end_date }] = queryKey;
  const userEmailParam = query ? `&user_email=${encodeURIComponent(query)}` : "";
  const startDateParam = `&start_date=${encodeURIComponent(start_date)}`;
  const endDateParam = `&end_date=${encodeURIComponent(end_date)}`;
  const url = `${GET_ALL_TRANSACTIONS}?page=${page}&pageSize=${pageSize}${userEmailParam}${startDateParam}${endDateParam}`;
  return fetch(url);
};

export const useGetAllTransactions = (params: any) => {
  return useQuery({
    queryKey: ["creditTransactions", params],
    queryFn: fetchCreditTransactions,
  });
};

export default useGetAllTransactions;
